module.exports = __webpack_public_path__ + "img/ec2ba21493a2b780d3542cc7ec0f7c1b-enable_2fa_1.png";